var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StateAnalysis',{attrs:{"title":"疲劳评价报告","report":"plReportHistories"}})
}
var staticRenderFns = []

export { render, staticRenderFns }